import type { Variation } from '@shared/types/types';
import type { ProductLink } from '@tile/components/product-title/ProductLink';

type Title = Variation['title'] | undefined;

export function mapLink(variation: Variation): ProductLink {
    return {
        href: resolveLink(variation.canonicalLink, variation.detailPageLink),
        detailPageLink: variation.detailPageLink,
        title: resolveLinkTitle(variation.title, variation.brand),
        index: variation.index ?? false,
    };
}

/**
 *
 *
 */
function resolveLinkTitle(title: Title, brand: string): string {
    if (title?.full) {
        return title.full;
    }

    const titleWithoutBrand = title?.withoutBrand ?? '';
    return titleWithoutBrand ? `${brand} ${titleWithoutBrand}` : brand;
}

/**
 *
 *
 *
 */
function resolveLink(canonicalLink: string | undefined, variationLink: string): string {
    return canonicalLink || variationLink;
}
